<div class="layout-row layout-align-start-center" (mouseenter)="hovered.set(true)" (mouseleave)="hovered.set(false)">
  <span container="body" [ngbTooltip]="displayId() ?? ''">
    <!-- ui-fallback: state links stay an admin component (routes through ui-router). Existing test id kept. -->
    <app-bringoz-state-link appBringozIdGenerator="threePlServiceLink"
                            state="threePLService.info"
                            [params]="params()"
                            [text]="displayId()">
    </app-bringoz-state-link>
  </span>

  @if (hovered()) {
    <bz-copy-button appBringozIdGenerator="threepl-service-link-copy-button"
                    [text]="displayId() ?? ''"
                    [label]="'Copy to clipboard' | translate"
                    (copied)="onCopied()">
    </bz-copy-button>
  }
</div>
